import React from 'react';
import * as M from '../Modules';
import StaticCard from '../StaticCard';

function WhereChaserHelpsGroup() {
  return (
    <section className="drm-final-group">
      <div className="drm-final-group-body">
        <StaticCard
          id="where-chaser-helps"
          label="Recommended next steps"
          className="drm-final-card--bare"
        >
          <M.WhereChaserCanHelp density="md" />
        </StaticCard>
      </div>
    </section>
  );
}

export default WhereChaserHelpsGroup;
